import * as React from 'react';
import styled from 'styled-components';
import TextInput from '../../components/TextInput';
import SymbolBox from '../../components/SymbolBox';
const Wrapper = styled.div `
  display: flex;
`;
const InputWrapper = styled.div `
  display: flex;
  flex: 0 0 auto;
  margin-bottom: 20px;
`;
const TopAllignedTextInput = styled(TextInput) `
  justify-content: flex-end;
`;
const ExampleText = styled.span `
  @import url('${({ font }) => font.fontUrl}');
  font-family: '${({ font }) => font.fontFamily}';
  font-size: ${({ fontSize }) => fontSize};
  line-height: ${({ lineHeight }) => lineHeight};
  margin-bottom: 38px;
  padding-left: 73px;
`;
const onFontSizeChange = (font, fontSizeName) => (event) => {
    font.sizes[fontSizeName].fontSize = event.target.value;
};
const onLineHeightChange = (font, fontSizeName) => (event) => {
    font.sizes[fontSizeName].lineHeight = event.target.value;
};
const FontSizeRow = ({ font, fontSizeName }) => (React.createElement(Wrapper, null,
    React.createElement(InputWrapper, null,
        React.createElement(SymbolBox, null, fontSizeName),
        React.createElement(TopAllignedTextInput, { name: `fontSize_${fontSizeName}`, label: "Font Size", value: font.sizes[fontSizeName].fontSize, onChange: onFontSizeChange(font, fontSizeName) }),
        React.createElement(TopAllignedTextInput, { name: `lineHeight_${fontSizeName}`, label: "Line height", value: font.sizes[fontSizeName].lineHeight, onChange: onLineHeightChange(font, fontSizeName) })),
    React.createElement(ExampleText, { font: font, fontSize: font.sizes[fontSizeName].fontSize, lineHeight: font.sizes[fontSizeName].lineHeight }, "Lorem ipsum")));
export default FontSizeRow;
